import axios from 'axios';
import { helpDeskUrl } from '../settings';

const API_URL = helpDeskUrl + '/api';

class HelpDeskService {
  sendContactForm(contactForm) {
    var formData = new FormData();
    if(contactForm.receiptId !== '')
    {
      contactForm.subject += ' | ' + contactForm.receiptId;
    }

    formData.append("title", contactForm.subject);
    formData.append("content", contactForm.message);
    formData.append("author_name", contactForm.name);
    formData.append("author_email", contactForm.email);
    formData.append("category_id", contactForm.categoryId);

    return axios.post(API_URL + '/ticketsapi', formData);
  }

  getCategories() {
    return axios.get(API_URL + '/categoriesapi');
  }
}

export default new HelpDeskService();